import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How do I contact support?',
    answer: 'You can reach us by email at info@caringhand.it.com or call us on 0800 055 4969 during business hours. We aim to respond to all enquiries within 24 hours.'
  }, {
    question: 'When does my service begin and end?',
    answer: 'Your service begins immediately after payment is confirmed and remains valid for 12 months from the start date. You will receive confirmation with your service dates via email.'
  }, {
    question: 'How do I book a repair?',
    answer: 'Contact us by phone or email to arrange an appointment. We typically schedule engineer visits within 24-48 hours of your request, subject to availability in your area.'
  }, {
    question: 'What appliances do you handle?',
    answer: 'We repair most domestic appliances including washing machines, dishwashers, tumble dryers, cookers, fridges, freezers, and televisions. Service is subject to appliance age and condition.'
  }, {
    question: 'What is your response time?',
    answer: 'We typically arrange engineer visits within 48 hours of your booking request. Remote areas may require additional time. We will always confirm the appointment date when you contact us.'
  }, {
    question: 'What is your refund and cancellation process?',
    answer: 'Full refunds are available within 14 days if no work has been carried out. Between 15-28 days, partial refunds may be granted at our discretion. After 28 days, no refunds are available. Please contact us to discuss your specific situation.'
  }, {
    question: 'How do I resolve a dispute?',
    answer: 'Please contact us first at info@caringhand.it.com or 0800 055 4969. We are committed to resolving any concerns quickly and fairly. Most issues can be addressed through direct communication with our support team.'
  }];
  return <section className="py-16 bg-white" data-id="element-119">
      <div className="max-w-4xl mx-auto px-4" data-id="element-120">
        <div className="text-center mb-12" data-id="element-121">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-122">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600" data-id="element-123">
            Find answers to common questions about our repair services
          </p>
        </div>
        <div className="space-y-4" data-id="element-124">
          {faqs.map((faq, index) => <div key={index} className="bg-gray-50 rounded-xl shadow-sm overflow-hidden" data-id="element-125">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors" data-id="element-126">
                <h3 className="font-semibold text-lg text-gray-900 pr-4" data-id="element-127">
                  {faq.question}
                </h3>
                <ChevronDown className={`text-[#0D7377] transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-128" />
              </button>
              {openIndex === index && <div className="px-6 pb-5 pt-2" data-id="element-129">
                  <p className="text-gray-600 leading-relaxed" data-id="element-130">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-131">
          <p className="text-gray-600 mb-4" data-id="element-132">
            Still have questions? We are here to help.
          </p>
          <a href="tel:08000554969" className="inline-block bg-[#E8956B] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#D67D54] transition-colors shadow-md hover:shadow-lg" data-id="element-133">
            Contact Support
          </a>
        </div>
      </div>
    </section>;
}